// 图片域名配置
// const IMAGE_DOMAIN = 'https://gwapi.digital-shield.com'  // 替换成你的实际图片域名
const IMAGE_DOMAIN = process.env.VUE_APP_API_DOMAIN  // 替换成你的实际图片域名
export function getImageUrl(url) {
  if (!url) return ''
  if (url.startsWith('http')) return url
  return `${IMAGE_DOMAIN}${url}`
}